<template>
    <div class="center px-3">
        <div class="flex flex-column pt-6 xl:pt-8 justify-content-center align-items-center text-center">
            <h1 class="flex main_title text-900 font-semibold mb-5 text-4xl xl:text-7xl lg:text-7xl md:text-6xl sm:text-6xl">
                {{ title }}
            </h1>
            <h2 class="flex font-normal text-700 
                pb-5 xl:pb-8 lg:pb-7 md:pb-6 sm:pb-6 
                text-2xl xl:text-4xl lg:text-4xl md:text-3xl sm:text-3xl">
                {{ subtitle }}
            </h2>
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'subtitle'],
}
</script>